/**
 * Helper para manejar variables de entorno de forma segura
 */

// Configuración de variables de entorno con valores por defecto
export const ENV_CONFIG = {
  API_URI: process.env.REACT_APP_API_URI || 'http://localhost:3001',
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || '/',
  NODE_ENV: process.env.NODE_ENV || 'development',
  LOGO: process.env.REACT_APP_LOGO || null,
  WEBSITE: process.env.REACT_APP_WEBSITE || '/',
  COLOR_PRIMARY: process.env.REACT_APP_COLOR_PRIMARY || '#1a97f5',
  COLOR_PRIMARY_DARK: process.env.REACT_APP_COLOR_PRIMARY_DARK || '#1682d4',
  COLOR_SECONDARY: process.env.REACT_APP_COLOR_SECONDARY || '#1e4db7',
  COLOR_SECONDARY_DARK: process.env.REACT_APP_COLOR_SECONDARY_DARK || '#173f98',
};

/**
 * Obtiene la URL base de la API
 * @returns {string} URL base de la API
 */
export const getApiUri = () => {
  if (!ENV_CONFIG.API_URI) {
    console.error('REACT_APP_API_URI no está definida');
    throw new Error('Variable de entorno REACT_APP_API_URI no configurada');
  }
  return ENV_CONFIG.API_URI;
};

/**
 * Construye una URL completa para un endpoint de la API
 * @param {string} endpoint - Endpoint de la API (ej: '/api/v1/sale')
 * @returns {string} URL completa
 */
export const buildApiUrl = (endpoint) => {
  const baseUrl = getApiUri();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

/**
 * Obtiene la configuración de colores personalizados
 * @returns {object} Objeto con colores personalizados
 */
export const getCustomColors = () => {
  return {
    primary: ENV_CONFIG.COLOR_PRIMARY,
    primaryDark: ENV_CONFIG.COLOR_PRIMARY_DARK,
    secondary: ENV_CONFIG.COLOR_SECONDARY,
    secondaryDark: ENV_CONFIG.COLOR_SECONDARY_DARK,
  };
};

/**
 * Obtiene la configuración de branding personalizado
 * @returns {object} Objeto con configuración de branding
 */
export const getBrandingConfig = () => {
  return {
    logo: ENV_CONFIG.LOGO,
    website: ENV_CONFIG.WEBSITE,
  };
};

/**
 * Valida que todas las variables de entorno requeridas estén configuradas
 * @returns {boolean} true si todas las variables están configuradas
 */
export const validateEnvironment = () => {
  const requiredVars = ['REACT_APP_API_URI'];
  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.error('Variables de entorno faltantes:', missingVars);
    return false;
  }
  
  return true;
};

// Validar entorno al cargar el módulo
if (process.env.NODE_ENV === 'development') {
  validateEnvironment();
}
